import * as Sentry from '@sentry/react';
import React, { useEffect, useMemo, useState } from "react";
import RenderIfVisible from "react-render-if-visible";
import { useDispatch } from "react-redux";

import Loading from "components/Loading";
import SpinLoader from "components/Loader/SpinLoader";
import styled from "styled-components";
import { DeleteModal } from "components/Dialog";
import { handleDeleteArticleLevel, handleListChapterArticle } from "store/StoryAiCofig/thunks";
import { map } from "lodash";
import { Row, message } from "antd";
import { useChapterArticleLevel } from "store/StoryAiCofig/selectors";
import ViewArticleLevels from "./ArticleViewModal";
import sysConf from "config";
import {
    Button,
    Checkbox,
    Chip,
    FormControl,
    FormHelperText,
    IconButton,
    InputLabel,
    ListItemText,
   
    MenuItem,
    Modal,
    OutlinedInput,
    Select
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
    CheckCircle,
    Close,
    Article
} from '@mui/icons-material';
import { useAlert } from 'components/UI/alertSakeBar/alertProvider';
import { getAwsAuthToken } from 'utils/lib/authHelper';
import AIUsageInfo from 'components/Modals/AiInfoModal';
import BadgeButton from '../../BadgeButton';

const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;
const ModalContentView = styled.div`
  left: 50%;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px; 
    @media only screen and (max-width: 600px) {
        min-width: 90% !important;
    }
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;

const CustomFormHelperText = styled(FormHelperText)`
 color:red !important;
  .MuiFormHelperText-root{
  color:red !important;
  }
`
const levelsData = [
    {
      value: "Intermediate-low",
      label:"Intermediate Low",
    },
    {
      value: "Intermediate-mid",
      label:"Intermediate Mid",
    },
    {
      value: "Intermediate-high",
      label: "Intermediate High",
    }
  ];

const useStyles = makeStyles((theme) => ({
    formControl: {
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: '4px',
    },
  }));
const ArticleLevelToolBar = ({ bookId, pageId , pages, hasPermission = true }) => {
      const showAlert = useAlert();
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteLoader, setDeleteLoader] = useState(false)
    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false)
    const article_levels = useChapterArticleLevel();
    const book_articles = useMemo(() => Array.isArray(article_levels) ? article_levels.filter((item) => item.chapter == bookId) : [], [bookId, article_levels]);
    const page_articles = useMemo(() => Array.isArray(book_articles) ? book_articles.filter((item) => item.page == pageId) : [], [book_articles, pageId]);
    const classes = useStyles();
    const dispatch = useDispatch()
    const [createConfigModal, setOpenCreateConfigModal] = useState(false);
    const [openArticleModal, setOpenArticleModal] = useState(false);
    const [selectedArticle, setSelectedArticle] = useState({});
    const [articleLevelTitle, setArticleLevelTitle] = useState('');
    const [articleLevelText, setArticleLevelText] = useState('');

    const [config, setConfig] = useState({
        proficiencyLevel: "Intermediate-low",
        pages:''
    });
    const [createLoader, setCreateLoader] = useState(false);
    useEffect(() => {
        if (articleLevelText || articleLevelTitle) {
            const sortedArticle = [...page_articles].sort(
              (a, b) => new Date(b.created_at) - new Date(a.created_at)
            );
            setSelectedArticle(sortedArticle[0]);
            setArticleLevelText('');
            setArticleLevelTitle('');
            return;
        }
        if (selectedArticle && selectedArticle.id) {
            const article = page_articles.find((item) => item.id == selectedArticle.id);
            if (article) {
                setSelectedArticle(article);
            } else {
                const article = page_articles[0] || {};
                setSelectedArticle(article);
            }
            setArticleLevelText('');
            setArticleLevelTitle('');
        } else {
            const article = page_articles[0] || {};
            setSelectedArticle(article);
            setArticleLevelText('');
            setArticleLevelTitle('');
        }

    }, [page_articles]);
 
    const onClose = () => {
        setOpenCreateConfigModal(false)
    }
    const onOpenModal = () => {
        if (!hasPermission) {
            message.warning('You do not have permission to access this feature.');
            return;
        }
        if(page_articles.length){
            setOpenArticleModal(true)
        } else {
            setOpenCreateConfigModal(true)
            setConfig(k => ({ ...k, pages: `${pageId}` }));
        }
    }
    const  checkAlreadyExis = () => {
        const article = page_articles.find((item) => item.config?.proficiencyLevel == config.proficiencyLevel);
        if(article){
            return true
        }else{
            return false
        }
    }
    const validatePageNum = (txt) => {
        if (!txt) {
            return true
        }
        const pageIds = txt.replace(/\s+/g, '').split(',').map(Number).filter(n => !Number.isNaN(n));
        if (pageIds.length > 3) {
            return false;
        }
        return true;
    }

    async function streamData(inputData, onChunk) {
      try {
        const token = await getAwsAuthToken();
        const response = await fetch(
          `${sysConf.apiGateway.AI_BASE_NODE_URL}/ArticleLevelAI/article-level-ai-stream`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'x-auth-source': sysConf.isDev ? 'test' : 'prod',
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify(inputData),
          },
        );

        if (!response.ok || !response.body) {
          throw new Error('Stream failed to start');
        }

        const reader = response.body.getReader();
        const decoder = new TextDecoder('utf-8');
        let pendingEvent = null;
        let title = '';
        let story = '';

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          const text = decoder.decode(value);
          const lines = text.split('\n').filter(Boolean);

          for (const line of lines) {
            if (line.startsWith('event:')) {
              pendingEvent = line.replace('event:', '').trim();
              continue;
            }
    
            if (!line.startsWith('data:')) continue;
    
            const data = line.replace('data:', '').trim();

            if (data === '[ERROR]') {
                showAlert("something went wrong please try with another page!","error");
                return;
            }
            if (data === '[DONE]') {
            //   dispatch(handleListStoryAiConfig({
            //     chapter,
            //     user_id: get(currentUser, "id", ""),
            //     class_id: get(currentClass, "id", "")
            //   }, is_student));            
            //   setLoader(false);
            //   clearAllState();
            //   onClose();
            
            showAlert("Article level created successfully","success")
              dispatch(handleListChapterArticle({chapter : bookId }));
              return;
            }
    
            if (pendingEvent === 'title') {
              try {
                title = JSON.parse(data);
                onChunk({ type: 'title', content: title });
              } catch (err) {
                console.error('Failed to parse title JSON:', data);
              }
              pendingEvent = null;
              continue;
            }
    
            try {
              const parsed = JSON.parse(data);
    
              if (parsed.type === 'chunk') {
                story += parsed.content;
                onChunk({ type: 'chunk', content: parsed.content });
              }
    
              if (parsed.type === 'error') {
                console.error('Server error:', parsed.message);
              }
    
            } catch (err) {
              console.error('Failed to parse JSON:', data);
            }
          }
        }
      } catch (error) {
        console.error('Stream error:', error);
        // setLoader(false);
      }
    }

    const createArticleLevel = async () => {
        setCreateLoader(true)
        if(checkAlreadyExis()){
            setError("Article level already exists. Please delete it before creating a new one.")
            setCreateLoader(false)
            return
        }
        setError(false)
        if(!pageId){
            setError("Please select page")
            setCreateLoader(false)
            return
        }
        if(!bookId){
            setError("Please select book")
            setCreateLoader(false)
            return
        }
        if(!isValidPagesInput(config.pages)){
            setError("Please enter valid pages")
            setCreateLoader(false)
            return
        }
        if(!validatePageNum(config.pages)){
            setError("You can only enter a maximum of 3 valid page IDs.")
            setCreateLoader(false)
            return
        }
        try {
    

            const data = {
                "chapter": bookId,
                "page": pageId,
                "config": {
                    ...config,
                },
                mode: import.meta.env.VITE_APP_STAGE?.trim() === "prod" ? "prod" : "dev",
            }

            let fullHTML = "";
            await streamData(data, (streamingData) => {
                setOpenCreateConfigModal(false);
                setOpenArticleModal(true);
                if (streamingData.type === 'title') {
                    setArticleLevelTitle(streamingData.content);
                } else if (streamingData.type === 'chunk') {
                    setSelectedArticle('');
                    fullHTML += streamingData.content;
                    setArticleLevelText(prev => prev + streamingData.content);
              }
            });

            // if(create_data && create_data.success){
            //     setOpenCreateConfigModal(false)
            //     if(Array.isArray(create_data.data)){
            //         setSelectedArticle(create_data.data[0]);
            //     }
            //     if (create_data.data[0]) {
            //         setOpenArticleModal(true);
            //         showAlert("Article level created successfully","success")
            //     }
            //     else {
            //         showAlert("something went wrong please try with another page!","error")
            //     }
                
            // } else {
            //     showAlert(create_data.message||"Something went wrong!","error")
            // }
        } catch (error) {
            console.log("error", error)
            Sentry.captureException(`310 Error creating article level: ${error}`);
            showAlert(`Something went wrong!`,"error")
        } finally{
            setCreateLoader(false)  
        }
    }

    const handleDelete = async () => {
        setDeleteLoader(true)
        try {
            const delete_data = await dispatch(handleDeleteArticleLevel(selectedArticle.id))
            if(delete_data && delete_data.success){
                showAlert("Article level deleted successfully","success")
                const other_articles = page_articles.find(article => article.id != selectedArticle.id)
                if(other_articles){
                    setSelectedArticle(other_articles)
                }else{
                    setSelectedArticle({})
                    setOpenArticleModal(false)
                }
            }else{
                showAlert(delete_data.message||"Something went wrong!","error")
            }
        } catch (error) {
            console.log("error", error)
            Sentry.captureException(`311 Error deleting article level: ${error}`);
            showAlert(`Something went wrong!`,"error")
        } finally{
            setDeleteLoader(false)  
            setDeleteModal(false)
        }
    }
    const isValidPagesInput = (value) => {
        const regex = /^(\d+)(,\d+)*$/;
        return regex.test(value);
    };
    return (<>
        <BadgeButton
            onClick={onOpenModal}
            startIcon={<Article />}
            showBadge={page_articles.length > 0}
            backgroundColor="#16a34a"
        >
            Article Levels
        </BadgeButton>
        <SpinLoader dataloader={loading} />
        <DeleteModal
            deleteToggle={deleteModal}
            loading={deleteLoader}
            onDelete={handleDelete}
            setDeleteToggle={setDeleteModal}
            message={`Are you sure you want to remove ${selectedArticle.articles_title} (${selectedArticle?.config?.proficiencyLevel || ''})?`} />
        <Modal
            open={createConfigModal}
            onClose={onClose}
            style={{ height: "100%", width: "100%" }}
        >
            <ModalContent style={{ width: "60vw", minHeight:"auto"  }}>
                <Row style={{ justifyContent: "space-between" }}>
                    <IconButton
                        onClick={() => onClose()}
                        style={{ padding: 0, marginRight: 10 }}
                    >
                        <Close color="secondary" />
                    </IconButton>
                    <AIUsageInfo styles={{ icon: { color: 'black' } }} />
                </Row>
                <ModalConfigArea style={{ overflow:"visible" }}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="typeId" style={{ backgroundColor: "#fff" }}>
                            Type
                        </InputLabel>
                        <Select
                            labelId="typeId"
                            id="typeId"
                            value={config.proficiencyLevel}
                            onChange={(e) => {
                                setConfig(k => ({ ...k, proficiencyLevel: e.target.value }));
                                setError(null)
                            }}
                        >
                            {map(levelsData, (bk) => (
                                <MenuItem key={bk.value} value={bk.value}>
                                    {bk.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl variant="outlined" className={classes.formControl} style={{ marginTop: 12 }}>
                        <InputLabel id="pages-label">Select Pages (max 3)</InputLabel>
                        <Select
                            labelId="pages-label"
                            multiple
                            value={typeof config.pages === "string"? config.pages.split(',').map(Number) : []}
                            onChange={(e) => {
                                const selectedValues = e.target.value;
                                const previousSelected = typeof config.pages === "string" ? config.pages.split(',').map(Number) : [];
                                if (selectedValues.length > previousSelected.length && selectedValues.length > 3) {
                                    showAlert("You can select a maximum of 3 pages.", "warning");
                                    return;
                                }
                                const value = selectedValues.join(',');
                                setConfig(k => ({ ...k, pages: value }));
                                setError(null);
                            }} 
                            input={<OutlinedInput label="Select Pages (max 3)" />}
                            renderValue={(selected) => (
                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                                  {selected.map((id) => {
                                    const match = pages.find(p => p.pageId == id);
                                    return <Chip key={id} label={match?.NumberMasked || id} />;
                                  })}
                                </div>
                              )}
                        >
                            {pages.map((page) => (
                                <MenuItem key={page.pageId} value={parseInt(page.pageId)}>
                                    <RenderIfVisible defaultHeight={24} stayRendered={true} visibleOffset={500}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                            <Checkbox
                                                checked={typeof config.pages ==="string"?config.pages?.split(',').includes(page.pageId?.toString?.()):false}
                                            />
                                            <ListItemText primary={page.NumberMasked} />
                                        </div>
                                    </RenderIfVisible>
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </ModalConfigArea>
                {error ? (
                    <CustomFormHelperText>
                        {error}
                    </CustomFormHelperText>
                ) : null}
                <Row
                    gutter={[24, 24]}
                    style={{ marginTop: 16, marginRight: 0, marginLeft: 0 }}
                >
                    <Button
                        fullWidth
                        onClick={createArticleLevel}
                        color="primary"
                        variant="contained"
                        disabled={createLoader}
                        startIcon={createLoader ? <Loading white size={14} /> : null}
                    >
                        Generate
                    </Button>
                </Row>
            </ModalContent>
        </Modal>
        <Modal
          open={openArticleModal}
          onClose={()=>{
            setOpenArticleModal(false)
          }}
          style={{ height: "100%", width: "100%" }}
        >
            <ModalContentView>
                <Row style={{ justifyContent: "flex-end" }}>
                    <IconButton
                        onClick={()=>{
                            setOpenArticleModal(false)
                          }}
                        style={{ padding: 0, marginRight: 10 }}
                    >
                        <Close color="secondary" />
                    </IconButton>
                </Row>
                {((selectedArticle && selectedArticle.id) || (articleLevelTitle || articleLevelText)) ? 
                    <ViewArticleLevels
                        selectedArticle={selectedArticle}
                        setSelectedArticle={setSelectedArticle}
                        articleLevelTitle={articleLevelTitle}
                        articleLevelText={articleLevelText}
                        page_articles={page_articles}
                        onDeleteArticles={() => setDeleteModal(true)}
                        onGenerateMore={() => {
                            setOpenCreateConfigModal(true)
                            setConfig(k => ({ ...k, pages: `${pageId}` }));
                        }} 
                    />
                : null}
            </ModalContentView>
        </Modal>
    </>)
}

export default ArticleLevelToolBar;